import { useEffect, useState } from "react";
export default function EscapeScheduleInput({value,onChange}:{value:string;onChange:(value:string)=>void}) {
  const [draft,setDraft]=useState(value);
  useEffect(()=>setDraft(value),[value]);
  return <input value={draft} placeholder="10:00, 12:00, 15:00" onChange={event=>setDraft(event.target.value)} onBlur={event=>{
    const times=draft.split(',').map(t=>t.trim()).filter(Boolean);
    const valid=times.every(t=>/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(t));
    event.currentTarget.setCustomValidity(valid?'':'Scrivi gli orari nel formato 18:00, 20:30');
    if(valid)onChange([...new Set(times)].join(', '));else event.currentTarget.reportValidity();
  }}/>;
}
